import script from "./AtbForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AtbForm.vue?vue&type=script&setup=true&lang=js"

import "./AtbForm.vue?vue&type=style&index=0&id=7a5665ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5665ba"]])

export default __exports__